<div class="wrapper cv-dialog-form organization-container">
  <div class="row" >
    <ng-container *ngFor="let formField of formFields">
		<div class="{{formField.customClass}}">

			<cv-form-field
			*ngIf="showFields && formField.simpleField"
			[options]="{
			  key: formField.key,
			  label: formField.label
			}"
			[model]="formBuilderConfig[formField.key]"
		  >
		  </cv-form-field>
			<ng-container *ngIf="showFields && !formField.simpleField">
				<div class="row">
					<div class="text-center">
						<h2>{{formBuilderConfig[formField.key].DisplayText}}</h2>
					</div>
					<div class="text-right">
						<button class="btn btn-primary" (click)="addFormArray(formField)">{{formBuilderConfig[formField.key].ButtonText}}</button>
					</div>
				</div>
				<div class="row" *ngFor="let arrayFormField of formField.child; let i = index;">
					<div class="col-md-11">
						<div class="row">
							<div class="col-md-4" *ngFor="let formFieldChild of arrayFormField;">
								<cv-form-field
									*ngIf="showFields && formFieldChild.simpleField"
									[options]="{
			  					key: formField.key,
			  					index: i,
			  					childKey: formFieldChild.key,
			  					label: formFieldChild.label
							}"
									[model]="formBuilderConfig[formField.key].child[i][formFieldChild.key]"
								>
								</cv-form-field>
							</div>
						</div>
					</div>
					<div class="col-md-1 remove-form-container-button">
							<button pButton icon="fa fa-trash" (click)="deleteRowFormArray(i, formField)"></button>
					</div>
				</div>
			</ng-container>

		</div>
    </ng-container>
  </div>
</div>
